/* app/ui/tabs/tabs */

define(
	'app/ui/tabs/tabs',[
		'jquery'
	],

	function ($) {

		var Tabs;

		var selectors = {
			container: '.js-tabs',
			trigger: '.js-tabs__trigger',
			target: '.js-tabs__target'
		};

		return {
			init: function () {
				Tabs = this;

				var $containers = $(selectors.container);

				if ($containers.length > 0) {
					$containers.on('click', selectors.trigger, Tabs._triggerClicked);

					if (window.location.hash) {
						var $triggers = $(selectors.trigger);
						var $match = Array.from($triggers).filter(function (x) { return x.href.indexOf(window.location.hash) !== -1 });
						if ($match) {
							$($match).trigger('click');
						}
					}
				}
			},

			_triggerClicked: function (event) {
				event.preventDefault();

				var $trigger = $(event.currentTarget);
				var $container = $trigger.closest(selectors.container);
				var $allTargets = $container.find(selectors.target);
				var $allTriggers = $container.find(selectors.trigger);

				var currentUrl = window.location.origin + window.location.pathname;
				//console.log({
				//	event,
				//	$trigger,
				//	target: $trigger[0].href.replace(currentUrl, '')
				//});

				var targetId = $trigger[0].href.replace(currentUrl, '');
				var $selectedTarget = $(targetId);
				var $selectedTriggers = Array.from($allTriggers).filter(function(x) { return x.href.indexOf(targetId) !== -1 });

				$allTargets.attr('aria-current', false);
				$selectedTarget.attr('aria-current', true);

				$allTriggers.attr('aria-current', false);
				$($selectedTriggers).attr('aria-current', true);
				$(window).resize();
			},
		};
	}
);
